import createNamespaceContext from './helper/createNamespaceContext';
export var AVP_CONTEXT = 'avpCtx';
export var AVPAnalyticsContext = createNamespaceContext(AVP_CONTEXT, 'AVPAnalyticsContext');